export default {
  isLoading: (state) => state.isSyncedSuccessfully === null,
}
